import * as React from 'react';
import { IOSSwitch } from './IOSSwitch';

export type SettingPersistSwitchProps = {
    /** 当前是否开启 */
    checked: boolean;
    /** 为 true 时轨道禁用并在拇指处展示 loading（请求进行中） */
    loading?: boolean;
    /** 是否禁用（与 loading 可同时存在，loading 时内部已禁用） */
    disabled?: boolean;
    /** 无障碍名称，一般为设置项文案 */
    'aria-label': string;
    /** MUI Switch 的 onChange；第二个参数为切换后的选中态 */
    onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    /** 可选样式类，透传给 IOSSwitch */
    className?: string;
};

/**
 * 即时保存场景下的 iOS 风格开关：在 IOSSwitch 上固定布局类名，统一支持 loading 态。
 * 用于自助点餐通用设置等「切换即调接口」的表单项。
 */
export function SettingPersistSwitch(props: SettingPersistSwitchProps) {
    const { checked, loading, disabled, 'aria-label': ariaLabel, onChange, className } = props;
    return (
        <IOSSwitch
            className={className}
            sx={{ flexShrink: 0, mt: 0.25 }}
            checked={checked}
            loading={loading}
            disabled={disabled}
            inputProps={{ 'aria-label': ariaLabel }}
            onChange={onChange}
        />
    );
}
